import { lazyLoad } from 'utils/loadable';

export const SocialMediaSettings = lazyLoad(
  () => import('./index'),
  module => module.SocialMediaSettings,
);
